import type { ReactNode } from 'react'

import type { InputProps } from '@gto/ui/input'
import { Input } from '@gto/ui/input'

import type { FieldShellProps } from './field-shell'
import { FieldShell } from './field-shell'

type TextFieldProps = FieldShellProps & {
  /** Class for the input surface itself; `className` styles the whole field (label + control + message). */
  inputClassName?: string
  /** Extra `Field.Description` content rendered beside the helper/error slot;
   *  Base UI folds its id into the input's `aria-describedby`. */
  messageSlot?: ReactNode
} & Omit<InputProps, 'className'>

/** DS replacement for MUI TextField (single-line). `type="number"` stays a native
 *  passthrough on purpose: callers hold string state and validate at submit, and
 *  NumberInput's Base UI clamping would make out-of-range error states unreachable. */
export const TextField = ({
  label,
  error,
  helperText,
  disabled,
  required,
  className,
  inputClassName,
  messageSlot,
  size = 'small',
  ...input
}: TextFieldProps) => (
  <FieldShell
    className={className}
    disabled={disabled}
    error={error}
    helperText={helperText}
    label={label}
    messageSlot={messageSlot}
    required={required}
    control={
      <Input
        aria-required={required === true ? true : undefined}
        className={inputClassName}
        disabled={disabled}
        size={size}
        {...input}
      />
    }
  />
)
